import { defineStore } from 'pinia'
import { toRaw } from 'vue'
import { useCabinetStore } from '@/components/cabinets/\@stores/cabinets'

export const useSearchStore = defineStore('search-store', {
  state: () => ({
    totalCount: 0,
    headerFilter: [],
    selected: [],
    selectedCount: 0,
    selectedLoading: false,
    searchObjects: null,
    singleCellEditing: false,
    masterParams: {},
    isFilteredByTags: false,
    isFilteredByTimeline: false,
    clearAll: false,
  }),

  getters: {
    getMasterParams: (state) => {
      const cabinetStore = useCabinetStore()
      let params = {}

      if (state.searchObjects && state.searchObjects.length)
        params.search = toRaw(state.searchObjects)

      if (state.headerFilter && state.headerFilter.length)
        params.filter = state.headerFilter

      const visibleColumns = cabinetStore.visibleColumns()
      if (visibleColumns.length)
        params.visibleColumns = visibleColumns

      return state.masterParams = params

    },
    getDocParams: (state) => {
      return {
        skip: state.skip,
        take: state.take,
        ...state.masterParams
      }
    },
    textSearchObjects: (state) => state.searchObjects && JSON.stringify(state.searchObjects.filter( obj => { return obj.type === 'text' }))
  },
  actions: {
    setMasterParams({search, filter}) {
      const parsedSearch = search && JSON.parse(search)
      const parsedFilter = filter && JSON.parse(filter)
      this.searchObjects = parsedSearch
      this.headerFilter = parsedFilter
    },
    setSearches(searchObjects) {
      let searchSet = new Set()
      const searchObjs = typeof searchObjects === 'string' ? JSON.parse(searchObjects) : searchObjects

      if (searchObjs && searchObjs.length) {
        return searchObjs.filter(obj => {
          if (!obj)
            return
          // only text needs to be checked for unique here because setSearches is only called from the
          // DxTagbox component (SearchBar.vue)
          // also hardcoding text is kinda gross.
          if (obj.type !== 'text')
            return true

          const existsInSet = searchSet.has(obj.text)
          searchSet.add(obj.text)
          return !existsInSet
        })
      }
    },
    filterSearchesByTypes(obj, type) {
      const typesObj = obj.filter(r => r.type === type)
      const searchTypesObj = obj.filter(r => r.type !== type)
      return typesObj ? [ ...searchTypesObj, ...[typesObj[typesObj.length - 1]] ] : [...searchTypesObj]
    },
    addSearchbarObj(newObj) {
      if(!this.searchObjects) {
        this.searchObjects = [newObj]
        return
      }

      const existingIndex = this.searchObjects.findIndex(val => val.type === newObj.type )
      // In the future we may want the ability to have multiple of one type.
      if (existingIndex === -1) { // non-existent
        this.searchObjects = [...this.searchObjects, newObj]
      } // existing: 0(1) approach
      else if (this.searchObjects[existingIndex]['text'] !== newObj['text']) {
        // const rawObj = toRaw(this.searchObjects)
        // Object.assign([], this.searchObjects, {[existingIndex]: newObj})

        this.searchObjects[existingIndex] = newObj

        // this.searchObjects = toRaw(this.searchObjects).splice(existingIndex, 1, newObj)//TODO: investigate - .splice()
      }
    },
    removeSearchbarObj(type) {
      if(this.searchObjects) {
        //assumes there is only one of the target type
        const existingIndex = this.searchObjects.findIndex(val => val.type === type )
        if (existingIndex >= 0)
          this.searchObjects = toRaw(this.searchObjects).splice(existingIndex, 1)
      }
    },
    setHeaderFilter(filter) {
      this.headerFilter = filter
      Object.assign(this.masterParams, {filter})
    },
    setTotalCount(count) {
      this.totalCount = count
    },
    setSingleCellEditing(mode) {
      this.singleCellEditing = mode
    },
    setSelected(selected) {
      this.selected = selected
    },
    setSelectedLoading(loadingStatus) {
      this.selectedLoading = loadingStatus
    },
    setSelectedCount(count) {
      this.selectedCount = count
    },
    resetMasterParams() {
      this.searchObjects = null
      this.headerFilter = []
      this.masterParams = {}
    }
  }
})
